import React from "react";
import { Actions } from "./index";
import { Link } from "react-router-dom";
import {PureFileIcon} from "../../dashboard/placeholder/sections/payments";
import {random} from "../../comms/appeal";
import {DotsIcon, TableDelete, TableEdit} from "../../../icons";

const MobilePlaceholder = ({ data }) => {

    return (
        <div>
            {data.map(key => {

                return <div className="table-mobile-card" key={key}>

                    <div className="table-mobile-card-header">
                        <div className="d-flex">
                            <div className="table-mobile-card-header-icon">
                                <PureFileIcon />
                            </div>

                            <div className="table-mobile-card-header-main">
                                <Link to="/"><div className="skeleton skeleton2 middle" style={{ width: random(120, 250) }} /></Link>
                                <div><div className="skeleton skeleton3 small" style={{ width: random(80, 150) }} /></div>
                            </div>
                        </div>
                        <div className="paylixecommerce-table-actions">
                            <DotsIcon />
                        </div>
                    </div>


                    <div className="table-mobile-card-body">
                        <div className="table-mobile-card-body-list">
                            <div><div><div className="skeleton skeleton3 small" style={{ width: random(50, 120) }} /></div><div><div className="skeleton skeleton1 medium" style={{ width: random(100, 180) }} /></div></div>
                            <div><div><div className="skeleton skeleton3 small" style={{ width: random(50, 120) }} /></div><div><div className="skeleton skeleton1 medium" style={{ width: random(100, 180) }} /></div></div>
                        </div>
                    </div>

                </div>
            })}

        </div>
    );
};

export default MobilePlaceholder;
